export default __webpack_public_path__ + "static/media/vpx.f5b10d93.svg";